export enum EBitfGraphQlParsers {
  BITF_GRAPH_QL_PARSER = 'graphQlParser',
  BITF_PIMCORE_PARSER = 'pimcoreParser',
  BITF_STRAPI_GRAPHQL_PARSER = 'strapiGraphQlParser',
}
